module.exports = __webpack_public_path__ + "static/radio_dzieciom-04aa8aeec309472fe376514f930a796c.jpg";